<header class="header">

  <app-cookie-bar></app-cookie-bar>

  <ng-container *ngTemplateOutlet="windows ? mobile : desktop"></ng-container>

  <ng-template #desktop>
    <div class="header__pre-header"  [style.backgroundColor]="catalogueService.getProperty('mainColor')">
      <div class="pre-header__name" [style.color]="catalogueService.getProperty('languageColor')">{{ catalogueService.getProperty('label') }}</div>
      <div class="pre-header__languages" [style.color]="catalogueService.getProperty('languageColor')">
        <div *ngFor="let lang of availableLanguages; last as isLast">
          <a (click)="setLang(lang)" class="pointer" [class.active]="translateService.currentLang === lang" [style.color]="catalogueService.getProperty('languageColor')">{{ 'COMMON.LANGS_' + lang.toUpperCase() | translate }}</a>
          <span class="not_mobile_only" [style.color]="catalogueService.getProperty('languageColor')" *ngIf="!isLast">&nbsp;|&nbsp;</span>
        </div>
      </div>
    </div>
    <div class="logo-menu-container" [style.backgroundColor]="catalogueService.getProperty('headerColor')">
      <div class="logo-container">
        <img src="{{catalogueService.getProperty('imageLogo') }}" (click)="goTo('home')" class="top-logo-img" *ngIf="catalogueService.getProperty('imageLogo')">
        <img ng-src="/assets/empty.png" class="top-logo-img" *ngIf="!catalogueService.getProperty('imageLogo')">
      </div>
      <div class="menu-container">
        <div class="header-icon" *ngIf="loginService.isAuth()" routerLink="/{{catalogueService.getProperty('eventName')}}/home" [queryParams]="{tab: 'favorites', lang: utilsService.mapLanguageCode(this.translateService.currentLang) }">
          <svg class="pointer user_icons" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" [style.fill]="catalogueService.getProperty('mainColor')">
            <path d="M16.5 3.6582C14.76 3.6582 13.09 4.4592 12 5.72498C10.91 4.4592 9.24 3.6582 7.5 3.6582C4.42 3.6582 2 6.05131 2 9.09709C2 12.8351 5.4 15.8809 10.55 20.5089L12 21.8043L13.45 20.499C18.6 15.8809 22 12.8351 22 9.09709C22 6.05131 19.58 3.6582 16.5 3.6582ZM12.1 19.0354L12 19.1343L11.9 19.0354C7.14 14.7733 4 11.955 4 9.09709C4 7.11931 5.5 5.63598 7.5 5.63598C9.04 5.63598 10.54 6.61498 11.07 7.96976H12.94C13.46 6.61498 14.96 5.63598 16.5 5.63598C18.5 5.63598 20 7.11931 20 9.09709C20 11.955 16.86 14.7733 12.1 19.0354Z" />
          </svg>
          <a class="pointer user-text">{{ 'HEADER.MY_FAVORITES' | translate }}</a>
        </div>
        <div class="header-icon" *ngIf="!loginService.isAuth()">
          <svg class="pointer user_icons" (click)="login()" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" [style.fill]="catalogueService.getProperty('mainColor')">
            <path d="M12 2.84375C6.48 2.84375 2 7.27397 2 12.7326C2 18.1913 6.48 22.6215 12 22.6215C17.52 22.6215 22 18.1913 22 12.7326C22 7.27397 17.52 2.84375 12 2.84375ZM7.07 18.9429C7.5 18.0529 10.12 17.1826 12 17.1826C13.88 17.1826 16.51 18.0529 16.93 18.9429C15.57 20.0109 13.86 20.6438 12 20.6438C10.14 20.6438 8.43 20.0109 7.07 18.9429ZM18.36 17.509C16.93 15.7883 13.46 15.2049 12 15.2049C10.54 15.2049 7.07 15.7883 5.64 17.509C4.62 16.1839 4 14.5324 4 12.7326C4 8.37164 7.59 4.82153 12 4.82153C16.41 4.82153 20 8.37164 20 12.7326C20 14.5324 19.38 16.1839 18.36 17.509ZM12 6.79931C10.06 6.79931 8.5 8.34197 8.5 10.2604C8.5 12.1789 10.06 13.7215 12 13.7215C13.94 13.7215 15.5 12.1789 15.5 10.2604C15.5 8.34197 13.94 6.79931 12 6.79931ZM12 11.7438C11.17 11.7438 10.5 11.0812 10.5 10.2604C10.5 9.43964 11.17 8.77708 12 8.77708C12.83 8.77708 13.5 9.43964 13.5 10.2604C13.5 11.0812 12.83 11.7438 12 11.7438Z" />
          </svg>
          <a class="pointer user-text" (click)="login()">{{ 'HEADER.LOGIN' | translate }}</a>
        </div>
        <div class="header-icon" *ngIf="loginService.isAuth()" (click)="toggleShowLoggedMenu()">
          <svg class="pointer user_icons" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" [style.fill]="catalogueService.getProperty('mainColor')">
            <path d="M12 2.84375C6.48 2.84375 2 7.27397 2 12.7326C2 18.1913 6.48 22.6215 12 22.6215C17.52 22.6215 22 18.1913 22 12.7326C22 7.27397 17.52 2.84375 12 2.84375ZM7.07 18.9429C7.5 18.0529 10.12 17.1826 12 17.1826C13.88 17.1826 16.51 18.0529 16.93 18.9429C15.57 20.0109 13.86 20.6438 12 20.6438C10.14 20.6438 8.43 20.0109 7.07 18.9429ZM18.36 17.509C16.93 15.7883 13.46 15.2049 12 15.2049C10.54 15.2049 7.07 15.7883 5.64 17.509C4.62 16.1839 4 14.5324 4 12.7326C4 8.37164 7.59 4.82153 12 4.82153C16.41 4.82153 20 8.37164 20 12.7326C20 14.5324 19.38 16.1839 18.36 17.509ZM12 6.79931C10.06 6.79931 8.5 8.34197 8.5 10.2604C8.5 12.1789 10.06 13.7215 12 13.7215C13.94 13.7215 15.5 12.1789 15.5 10.2604C15.5 8.34197 13.94 6.79931 12 6.79931ZM12 11.7438C11.17 11.7438 10.5 11.0812 10.5 10.2604C10.5 9.43964 11.17 8.77708 12 8.77708C12.83 8.77708 13.5 9.43964 13.5 10.2604C13.5 11.0812 12.83 11.7438 12 11.7438Z" />
          </svg>
          <a class="pointer user-text">{{ 'HEADER.MY_ACCOUNT' | translate }}</a>
        </div>
        <div class="logged-menu" [ngClass]="{ 'logged-menu--showed': showLoggedMenu }" [style.backgroundColor]="catalogueService.getProperty('headerColor')">
          <div class="logged-menu__item" (click)="goTo('profile')">
            <img class="pointer" width="24" height="24" alt="account" src="assets/img/account_circle.svg">
            <span>{{ 'HEADER.PROFILE' | translate }}</span>
          </div>
          <div class="logged-menu__item" (click)="goTo('change-password')">
            <img class="pointer" width="24" height="24" alt="account" src="assets/img/account_circle.svg">
            <span>{{ 'HEADER.CHANGE_PASSWORD' | translate }}</span>
          </div>
          <div class="logged-menu__item" (click)="goTo('my-exhibitor')" *ngIf="rolesService.isSingleExhibitor() && !rolesService.hasRoles([roles['BACKOFFICE'], roles['SUPERADMIN']])">
            <img class="pointer" width="24" height="24" alt="account" src="assets/img/admin_panel_settings.svg">
            <span>{{ 'HEADER.EXHIBITOR' | translate }}</span>
          </div>
          <div class="logged-menu__item" (click)="goTo('my-exhibitor')" *ngIf="rolesService.isMultipleExhibitor() && !rolesService.hasRoles([roles['BACKOFFICE'], roles['SUPERADMIN']])">
            <img class="pointer" width="24" height="24" alt="account" src="assets/img/admin_panel_settings.svg">
            <span>{{ 'HEADER.MULTIPLE_EXHIBITOR' | translate }}</span>
          </div>
          <div class="logged-menu__item" (click)="goTo('my-exhibitor')" *ngIf="rolesService.hasRoles([roles['BACKOFFICE'], roles['MULTIEXHIBITOR'], roles['SUPERADMIN']])">
            <img class="pointer" width="24" height="24" alt="account" src="assets/img/admin_panel_settings.svg">
            <span>{{ 'HEADER.BACKOFFICE' | translate }}</span>
          </div>
          <div class="logged-menu__item" (click)="goToBackOfficeUrl()" *ngIf="rolesService.hasRoles([roles['BACKOFFICE'], roles['SUPERADMIN']])">
            <img class="pointer" width="24" height="24" alt="account" src="assets/img/admin_panel_settings.svg">
            <span>{{ 'HEADER.EXTERNAL_BACKOFFICE' | translate }}</span>
          </div>
          <div class="logged-menu__item logged-menu__item--last" (click)="logoutBtn()">
            <img class="pointer" width="24" height="24" alt="logout" src="assets/img/logout.svg">
            <span>{{ 'HEADER.LOGOUT' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #mobile>
    <div class="header__pre-header" [style.backgroundColor]="catalogueService.getProperty('mainColor')">
      <div class="pre-header__name" [style.color]="catalogueService.getProperty('languageColor')">
        {{ catalogueService.getProperty('label') }}
      </div>
      <a (click)="openMenuMobile()" class="menu-mobile">
        <img class="pointer hamburger-mobile" 
             [title]="'menuMobile'" 
             src="assets/icons/menu-mobile.svg">
      </a>
    </div>
  
    <div>
      <div class="logo-container">
        <img *ngIf="catalogueService.getProperty('imageLogo')"
             [src]="catalogueService.getProperty('imageLogo')" 
             (click)="goTo('home')" 
             class="top-logo-img">
        <img *ngIf="!catalogueService.getProperty('imageLogo')" 
             ng-src="/assets/empty.png" 
             class="top-logo-img">
      </div>
    </div>
  
    <div class="mobile_only">
      <div class="user-overlay" *ngIf="isMobileOpen" (click)="openHeaderMenu()"></div>
      
      <nav id="user-options" class="user-menu-mobile" *ngIf="isMobileOpen" role="menu"
           [style.backgroundColor]="getBackgroundColor()">
        
        <a *ngIf="!loginService.isAuth()" class="pointer user-mobile-links" (click)="openMenuMobile(); login()">
          {{ 'HEADER.LOGIN' | translate }} 
        </a>
  
        <a *ngIf="!loginService.isAuth()" class="pointer user-mobile-links" (click)="openMenuMobile(); login()">
          <span class="favorite-text">{{ 'HEADER.MY_FAVORITES' | translate }}</span>
          <icon-favorite-empty class="favorite-icon" [color]="favoriteEmptyColor" (click)="onDelete()"></icon-favorite-empty>
        </a>
  
        <!--<ng-container [ngClass]="{ 'logged-menu--showed': showLoggedMenu }">-->
        <ng-container>
          <a class="pointer user-mobile-links" *ngIf="loginService.isAuth()" 
             (click)="goTo('profile')">
            {{ 'HEADER.PROFILE' | translate }} 
          </a>
          <a *ngIf="loginService.isAuth()" class="pointer user-mobile-links" 
             routerLink="/{{catalogueService.getProperty('eventName')}}/home" [queryParams]="{tab: 'favorites', lang: utilsService.mapLanguageCode(this.translateService.currentLang) }">
            <span class="favorite-text">{{ 'HEADER.MY_FAVORITES' | translate }} </span>
            <icon-favorite-empty class="favorite-icon" [color]="favoriteEmptyColor" (click)="onDelete()"></icon-favorite-empty>
          </a>
          
        </ng-container>
  
        <div class="languages" [ngClass]="!loginService.isAuth() ? 'loggedIn' : ''">
          <a class="pointer user-mobile-links" [ngClass]="isLanguagesOpen ? 'open' : ''" (click)="openLanguages()">
            <div class="row">
              <div class="current-lang col-10">
                <!--<span>{{ _('languages_title', 'Languages') }}</span>-->
                <div *ngIf="!isLanguagesOpen" class="current-lang-label">
                  {{ 'COMMON.LANG' | translate }} 
                    {{ 'COMMON.LEFT_PARENTHESIS' | translate }}
                      {{ 'COMMON.LANGS_' + translateService.currentLang.toUpperCase() | translate }}
                    {{ 'COMMON.RIGHT_PARENTHESIS' | translate }}
                </div>
                <div *ngIf="isLanguagesOpen" class="current-lang-label">
                  {{ 'COMMON.LANG' | translate }}
                </div>
              </div>
              <div *ngIf="isLanguagesOpen" class="col-1">
                <span aria-hidden="true"><fa-icon [icon]="faCaretDown"></fa-icon></span>
              </div>
              <div *ngIf="!isLanguagesOpen" class="col-1">
                <span aria-hidden="true"><fa-icon [icon]="faCaretRight"></fa-icon></span>
              </div>
            </div>
          </a>
          
          <div *ngIf="isLanguagesOpen">
            <ng-container *ngFor="let lang of availableLanguages; last as isLast">
              <a class="pointer language-selector user-links" 
                (click)="setLang(lang)"
                [class.bold]="translateService.currentLang === lang">
                  {{ 'COMMON.LANGS_LONG_' + lang.toUpperCase() | translate }}
              </a>
            </ng-container>
          </div>
        </div>
  
        <a *ngIf="loginService.isAuth()" class="pointer user-mobile-links" (click)="logoutBtn()">
          {{ 'HEADER.LOGOUT' | translate }} 
        </a>
      </nav>
    </div>
  </ng-template>
  

  
  <div class="lower-header" [style.background]="'linear-gradient(90deg, ' + catalogueService.getProperty('mainColor') + ' 0%, ' + catalogueService.getProperty('featuredColor') + ' 31.08%, ' + catalogueService.getProperty('mainColor') + ' 53.99%, ' + catalogueService.getProperty('featuredColor') + ' 77.95%, ' + catalogueService.getProperty('mainColor') + ' 99.83%)'"></div>
</header>
